(() => {
  if (window.SajadaCollectionFilter) {
    window.SajadaCollectionFilter.init(document);
    return;
  }

  const selector = '[data-aj-collection-filter]';
  const readStorage = (storage, key) => {
    try { return window[storage].getItem(key); } catch (_) { return null; }
  };
  const writeStorage = (storage, key, value) => {
    try { window[storage].setItem(key, value); } catch (_) { /* Private browsing can disable storage. */ }
  };

  function initWrapper(wrapper) {
    if (wrapper.ajCollectionFilter) return;
    wrapper.ajCollectionFilter = true;
    const slot = wrapper.querySelector('.aj-filter-collections');
    const status = wrapper.querySelector('.aj-filter-status');
    const moreContainer = wrapper.querySelector('.aj-view-more-container');
    const more = wrapper.querySelector('.aj-view-more-btn');
    const less = wrapper.querySelector('.aj-view-less-btn');
    const buttons = [...wrapper.querySelectorAll('.aj-filter-btn')];
    const sectionId = wrapper.dataset.sectionId;
    const storageKey = 'aj_active_tab_' + window.location.pathname + '_shopify-section-' + sectionId;
    const firstTarget = slot.querySelector('.aj-collection-grid')?.id;
    const cache = new Map();
    let controller;
    let revision = 0;
    let loading = false;

    const currentGrid = () => slot.querySelector('.aj-collection-grid.active');
    const getStep = () => {
      const fiveColumns = window.matchMedia('(min-width: 48em)').matches && wrapper.dataset.desktopCols === '5';
      return parseInt(fiveColumns ? wrapper.getAttribute('data-items-per-page-5col') : wrapper.dataset.itemsPerPage, 10) || 12;
    };
    const visibleCount = (grid) => parseInt(grid.dataset.visible, 10) || getStep();
    const cards = (grid) => [...grid.querySelectorAll(':scope > .aj-product-card')];

    function sectionURL(path, page) {
      const url = new URL(path, window.location.origin);
      const localeRoot = window.Shopify?.routes?.root;
      if (localeRoot && localeRoot !== '/' && url.pathname.startsWith('/collections/')) {
        url.pathname = localeRoot.replace(/\/$/, '') + url.pathname;
      }
      const current = new URL(window.location.href);
      ['preview_theme_id', '_fd', 'pb'].forEach((key) => {
        if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
      });
      url.searchParams.set('section_id', sectionId);
      // Render the source collection template even when another collection has a different assignment.
      if (wrapper.dataset.templateView) url.searchParams.set('view', wrapper.dataset.templateView);
      if (page !== undefined) {
        if (page > 1) url.searchParams.set('page', page);
        else url.searchParams.delete('page');
      }
      return url;
    }

    function markBusy(busy) {
      loading = busy;
      slot.setAttribute('aria-busy', String(busy));
      if (more) more.disabled = busy;
      if (less) less.disabled = busy;
      if (more) more.textContent = busy ? 'Loading...' : (wrapper.dataset.textMore || 'Load More');
    }

    function primeImages(grid) {
      cards(grid).filter((card) => card.style.display !== 'none').forEach((card, index) => {
        const image = card.querySelector('.product-card__image--primary img');
        if (!image) return;
        image.loading = index < 4 ? 'eager' : 'lazy';
        image.decoding = 'async';
        if (index < 4) image.setAttribute('fetchpriority', 'high');
        else image.removeAttribute('fetchpriority');
        if (image.complete) image.closest('.shimmer')?.classList.remove('shimmer');
      });
    }

    function setVisible(grid, count) {
      const productCards = cards(grid);
      grid.dataset.visible = Math.min(count, productCards.length);
      productCards.forEach((card, index) => { card.style.display = index < count ? '' : 'none'; });
      grid.querySelectorAll(':scope > .aj-grid-injected-block').forEach((block) => {
        block.style.display = Number(block.dataset.afterProduct) <= count ? '' : 'none';
      });
      primeImages(grid);
    }

    wrapper.ajUpdateButtonUI = (grid) => {
      if (!moreContainer || !grid) return;
      const visible = visibleCount(grid);
      const canLoadMore = visible < cards(grid).length || Boolean(grid.dataset.currentNextUrl);
      moreContainer.style.display = visible > getStep() || canLoadMore ? 'flex' : 'none';
      if (more) more.style.display = canLoadMore ? 'block' : 'none';
      if (less) less.style.display = !canLoadMore && visible > getStep() ? 'block' : 'none';
    };

    wrapper.ajResetGrid = (grid, updateUI = true) => {
      grid.querySelectorAll(':scope > .aj-ajax-loaded').forEach((node) => {
        node.querySelectorAll('.swiper-initialized').forEach((container) => container.swiper?.destroy(true, true));
        node.remove();
      });
      grid.dataset.currentNextUrl = grid.dataset.originalNextUrl || '';
      setVisible(grid, getStep());
      if (updateUI) wrapper.ajUpdateButtonUI(grid);
    };

    function syncFilterButtons(target) {
      buttons.forEach((button) => {
        const active = button.dataset.target === target;
        button.classList.toggle('active', active);
        button.setAttribute('aria-pressed', String(active));
        button.closest('.swiper-slide')?.classList.toggle('active', active);
      });
    }

    function initializeSliders() {
      if (!wrapper.isConnected || typeof window.Swiper !== 'function') return;
      const filter = wrapper.querySelector('.aj-filter-swiper');
      if (filter && !filter.swiper) {
        new window.Swiper(filter, {
          slidesPerView: 'auto', spaceBetween: 0, slidesOffsetAfter: 20,
          observer: true, observeParents: true, freeMode: true, watchSlidesProgress: true,
          scrollbar: { el: filter.querySelector('.swiper-scrollbar'), hide: false, draggable: true },
          breakpoints: { 768: { spaceBetween: 10, slidesOffsetAfter: 10 } },
        });
      }
      wrapper.querySelectorAll('.aj-sp-slider-wrapper').forEach((slider) => {
        const container = slider.querySelector('.aj-sp-swiper');
        if (!container) return;
        const cols = wrapper.dataset.desktopCols || '4';
        const desktopSlides = parseFloat(cols === '5' ? container.getAttribute('data-desktop-5') : container.dataset.desktop) || 4;
        container.classList.remove('aj-sp-swiper-4', 'aj-sp-swiper-5');
        container.classList.add('aj-sp-swiper-' + cols);
        if (!container.swiper) {
          new window.Swiper(container, {
            slidesPerView: parseFloat(container.dataset.mobile) || 1.2, spaceBetween: 15,
            observer: true, observeParents: true,
            navigation: { nextEl: slider.querySelector('.swiper-button-next'), prevEl: slider.querySelector('.swiper-button-prev') },
            breakpoints: { 768: { slidesPerView: desktopSlides, spaceBetween: 20 } },
          });
        } else {
          if (window.innerWidth >= 768) container.swiper.params.slidesPerView = desktopSlides;
          if (container.swiper.params.breakpoints?.[768]) container.swiper.params.breakpoints[768].slidesPerView = desktopSlides;
          container.swiper.update();
        }
      });
    }

    function readySliders() {
      if (window.SajadaSwiper) window.SajadaSwiper.ready(initializeSliders);
      else if (typeof window.Swiper === 'function') initializeSliders();
      else document.addEventListener('sajada:swiper:loader-ready', readySliders, { once: true });
    }

    function parseResponse(html, target) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const sourceWrapper = [...doc.querySelectorAll(selector)].find((node) => node.dataset.sectionId === sectionId);
      const sourceSlot = sourceWrapper?.querySelector('.aj-filter-collections');
      const grid = sourceSlot?.querySelector('.aj-collection-grid');
      if (!grid || grid.id !== target) throw new Error('The requested collection could not be rendered.');
      sourceSlot.querySelectorAll('.aj-pagination-wrapper a').forEach((link) => {
        const url = new URL(link.getAttribute('href'), sectionURL(grid.dataset.collectionUrl));
        url.searchParams.delete('section_id');
        link.href = url.toString();
      });
      return sourceSlot;
    }

    async function fetchSlot(url, target, signal, useCache = true) {
      const key = url.toString();
      if (useCache && cache.has(key)) return parseResponse(cache.get(key), target);
      const response = await fetch(key, { signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error('Unable to load products.');
      const html = await response.text();
      const sourceSlot = parseResponse(html, target);
      if (useCache) cache.set(key, html);
      return sourceSlot;
    }

    function updatePageURL(page, target, push) {
      const url = new URL(window.location.href);
      if (page > 1) url.searchParams.set('page', page);
      else url.searchParams.delete('page');
      const state = { ...(window.history.state || {}), ajCollectionTarget: target, ajCollectionSection: sectionId };
      window.history[push ? 'pushState' : 'replaceState'](state, '', url);
    }

    async function selectCollection(button, page = 1, updateHistory = false, pushHistory = false) {
      const target = button.dataset.target;
      const existing = currentGrid();
      if (!loading && existing?.id === target && Number(existing.dataset.currentPage) === page) return;
      controller?.abort();
      controller = new AbortController();
      const requestRevision = ++revision;
      const reservedHeight = slot.getBoundingClientRect().height;
      let selected = false;
      slot.style.minHeight = reservedHeight + 'px';
      markBusy(true);
      status.textContent = '';
      try {
        const sourceSlot = await fetchSlot(sectionURL(button.dataset.collectionUrl, page), target, controller.signal);
        if (requestRevision !== revision || !wrapper.isConnected) return;
        slot.querySelectorAll('.swiper-initialized').forEach((container) => container.swiper?.destroy(true, true));
        slot.replaceChildren(...[...sourceSlot.childNodes]);
        const grid = currentGrid();
        syncFilterButtons(target);
        setVisible(grid, getStep());
        wrapper.ajUpdateButtonUI(grid);
        writeStorage('sessionStorage', storageKey, target);
        if (updateHistory) updatePageURL(page, target, pushHistory);
        if (pushHistory) {
          window.scrollTo({ top: wrapper.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
        }
        readySliders();
        selected = true;
      } catch (error) {
        if (requestRevision === revision && error.name !== 'AbortError') {
          status.textContent = 'Products could not be loaded. Please try again.';
          console.error('Collection filter:', error);
        }
      } finally {
        if (requestRevision === revision) {
          markBusy(false);
          slot.style.minHeight = '';
          const grid = currentGrid();
          if (selected && grid && cards(grid).length < getStep() && grid.dataset.currentNextUrl) loadProducts(getStep());
        }
      }
    }

    buttons.forEach((button) => button.addEventListener('click', (event) => {
      event.preventDefault();
      selectCollection(button, 1, true);
    }));

    slot.addEventListener('click', (event) => {
      const link = event.target.closest('.aj-pagination-wrapper a');
      if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const grid = currentGrid();
      const button = buttons.find((candidate) => candidate.dataset.target === grid?.id);
      if (!button) return;
      event.preventDefault();
      const page = parseInt(new URL(link.href, window.location.origin).searchParams.get('page'), 10) || 1;
      selectCollection(button, page, true, true);
    });

    async function loadProducts(count) {
      if (loading) return;
      const grid = currentGrid();
      if (!grid) return;
      if (count <= cards(grid).length || !grid.dataset.currentNextUrl) {
        setVisible(grid, count);
        wrapper.ajUpdateButtonUI(grid);
        return;
      }
      controller?.abort();
      controller = new AbortController();
      const requestRevision = ++revision;
      markBusy(true);
      status.textContent = '';
      try {
        // The first page remains small; a 5-column layout may need more than one page for its step.
        while (cards(grid).length < count && grid.dataset.currentNextUrl) {
          const sourceSlot = await fetchSlot(sectionURL(grid.dataset.currentNextUrl), grid.id, controller.signal, false);
          if (requestRevision !== revision || currentGrid() !== grid) return;
          const sourceGrid = sourceSlot.querySelector('.aj-collection-grid');
          const offset = cards(grid).length;
          const newCards = cards(sourceGrid);
          if (!newCards.length) throw new Error('The next product page is empty.');
          [...sourceGrid.children].forEach((node) => {
            node.classList.add('aj-ajax-loaded');
            if (node.classList.contains('aj-grid-injected-block')) node.dataset.afterProduct = offset + Number(node.dataset.afterProduct);
            grid.appendChild(node);
          });
          grid.dataset.currentNextUrl = sourceGrid.dataset.currentNextUrl || '';
        }
        setVisible(grid, count);
        readySliders();
      } catch (error) {
        if (requestRevision === revision && error.name !== 'AbortError') {
          status.textContent = 'More products could not be loaded. Please try again.';
          console.error('Collection load more:', error);
        }
      } finally {
        if (requestRevision === revision) {
          markBusy(false);
          wrapper.ajUpdateButtonUI(grid);
        }
      }
    }

    more?.addEventListener('click', () => {
      const grid = currentGrid();
      if (grid) loadProducts(Math.max(getStep(), visibleCount(grid)) + getStep());
    });

    less?.addEventListener('click', () => {
      const grid = currentGrid();
      if (!grid || loading) return;
      setVisible(grid, Math.max(getStep(), visibleCount(grid) - getStep()));
      wrapper.ajUpdateButtonUI(grid);
    });

    function syncGridButtons() {
      wrapper.querySelectorAll('.aj-grid-selector__btn').forEach((button) => {
        const selected = button.dataset.gridTarget === 'desktop' ? wrapper.dataset.desktopCols : wrapper.dataset.mobileCols;
        const active = button.dataset.gridCols === selected;
        button.classList.toggle('aj-grid-selector__btn--active', active);
        button.setAttribute('aria-pressed', String(active));
      });
    }

    if (wrapper.hasAttribute('data-grid-selector-enabled')) {
      const desktop = readStorage('localStorage', 'collection_grid_desktop');
      const mobile = readStorage('localStorage', 'collection_grid_mobile');
      if (desktop === '4' || desktop === '5') wrapper.dataset.desktopCols = desktop;
      if (mobile === '1' || mobile === '2') wrapper.dataset.mobileCols = mobile;
      syncGridButtons();
      wrapper.addEventListener('click', (event) => {
        const button = event.target.closest('.aj-grid-selector__btn');
        if (!button || loading) return;
        if (button.dataset.gridTarget === 'desktop') wrapper.dataset.desktopCols = button.dataset.gridCols;
        else wrapper.dataset.mobileCols = button.dataset.gridCols;
        writeStorage('localStorage', 'collection_grid_' + button.dataset.gridTarget, button.dataset.gridCols);
        syncGridButtons();
        wrapper.dispatchEvent(new CustomEvent('aj:grid:changed'));
        const grid = currentGrid();
        if (grid) {
          wrapper.ajResetGrid(grid);
          if (cards(grid).length < getStep() && grid.dataset.currentNextUrl) loadProducts(getStep());
        }
        readySliders();
      });
    }

    const grid = currentGrid();
    if (grid) {
      setVisible(grid, getStep());
      syncFilterButtons(grid.id);
      wrapper.ajUpdateButtonUI(grid);
      updatePageURL(Number(grid.dataset.currentPage) || 1, grid.id, false);
    }
    readySliders();
    const savedTarget = readStorage('sessionStorage', storageKey);
    const savedButton = buttons.find((button) => button.dataset.target === savedTarget);
    if (savedButton && savedTarget !== grid?.id) {
      selectCollection(savedButton, parseInt(new URL(window.location.href).searchParams.get('page'), 10) || 1, true);
    } else if (grid && cards(grid).length < getStep() && grid.dataset.currentNextUrl) {
      loadProducts(getStep());
    }

    const onPopState = (event) => {
      if (!wrapper.isConnected) {
        window.removeEventListener('popstate', onPopState);
        return;
      }
      if (event.state?.ajCollectionSection && event.state.ajCollectionSection !== sectionId) return;
      const target = event.state?.ajCollectionTarget || firstTarget;
      const button = buttons.find((candidate) => candidate.dataset.target === target);
      if (button) selectCollection(button, parseInt(new URL(window.location.href).searchParams.get('page'), 10) || 1);
    };
    window.addEventListener('popstate', onPopState);
  }

  function init(root) {
    if (root.matches?.(selector)) initWrapper(root);
    root.querySelectorAll(selector).forEach(initWrapper);
  }
  window.SajadaCollectionFilter = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
